import { differenceInMinutes } from 'date-fns'
import { toDate } from 'date-fns-tz'

const ALLOWED_MINUTES_BEFORE_SHIFT_START = 360

type canCreatePunchCardArgs = {
  start: string
  startTimezone: string
  allowedInterval?: number
}
export const canCreatePunchCard = ({ start, startTimezone, allowedInterval = ALLOWED_MINUTES_BEFORE_SHIFT_START }: canCreatePunchCardArgs): boolean => {
  // Build a Date instance attaching the timezone to it (the date argument is a string of format '2023-03-06T12:00:00' without timezone)
  const parsedStart = toDate(start, { timeZone: startTimezone })
  const parsedStartSinceEpoch = parsedStart.getTime()
  const today = new Date()
  const todaySinceEpoch = today.getTime()

  const differenceInMinutesFromStart = differenceInMinutes(parsedStartSinceEpoch, todaySinceEpoch)
  const isShiftStartInPast = differenceInMinutesFromStart <= 0
  const isShiftStartInAllowedInterval = !isShiftStartInPast && differenceInMinutesFromStart < allowedInterval

  return isShiftStartInPast || isShiftStartInAllowedInterval
}
